import type { ReactNode } from "react";

/**
 * Workbench template (product lock 2026-08-15, lock 2): Setup, Patrols, Admin, Platform,
 * Schedule hub. Pair with `stage: "stage"` in route-templates.ts.
 *
 * The head is the first-viewport answer to where am I / what needs attention / where do I
 * click next; it never scrolls away. The body is the stage scroller: the page scrolls only
 * to move between panes, and long lists live inside `.shell-pane` scrollers so the app
 * chrome never scrolls to reach row 40.
 */
export function WorkbenchLayout({
  subrail,
  head,
  children,
  className,
}: {
  /** Usually a ShellSubrail; it portals to the shell's subrail cell from here. */
  subrail?: ReactNode;
  head?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={className !== undefined ? `wb ${className}` : "wb"}>
      {subrail}
      {head !== undefined ? <header className="wb__head">{head}</header> : null}
      <div className="wb__body">{children}</div>
    </div>
  );
}
